import { render, staticRenderFns } from "./CustomersComponent.vue?vue&type=template&id=6fc457bc&"
import script from "./CustomersComponent.vue?vue&type=script&lang=js&"
export * from "./CustomersComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports